import { render, staticRenderFns } from "./NewHousing.vue?vue&type=template&id=5b324ee7&scoped=true"
import script from "./NewHousing.vue?vue&type=script&lang=js"
export * from "./NewHousing.vue?vue&type=script&lang=js"
import style0 from "./NewHousing.vue?vue&type=style&index=0&id=5b324ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b324ee7",
  null
  
)

export default component.exports